export const CategoryCard = ({ category, index }) => (
  <article
    data-testid={`category-card-${category.slug}`}
    className="group flex h-full flex-col overflow-hidden rounded-lg border border-[#0B1F33]/10 bg-white shadow-sm transition-shadow duration-200 hover:shadow-md"
  >
    <div className="aspect-[16/10] w-full overflow-hidden bg-[#F4F6F8]">
      <img
        src={category.image}
        alt={category.alt}
        width="800"
        height="500"
        loading={index < 2 ? "eager" : "lazy"}
        decoding="async"
        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
      />
    </div>
    <div className="flex flex-1 flex-col p-6">
      <h3 className="text-lg font-bold text-[#0B1F33]">{category.title}</h3>
      <p className="mt-3 text-sm leading-relaxed text-[#263238]">{category.description}</p>
    </div>
  </article>
);

export default CategoryCard;
